import '../commons';
import '../uikitv2-user';

import 'jquery-lazy';
// include from proengsoft/laravel-jsvalidation in laravel framework
// https://github.com/proengsoft/laravel-jsvalidation

//have error webpack
//import '../../../../../../public/vendor/jsvalidation/js/jsvalidation'

/*
 ต้องใช้ v.13.0.3 เพราะ ntl-tel-input ver 14ขึ้นไป remove jquery dependency
https://github.com/jackocnr/intl-tel-input/issues/774
*/
import intlTelInput from 'intl-tel-input';
import { log } from 'util';
window.intlTelInput = intlTelInput;

$(function () {
    $(document).ready(function () {
        scrollSpeed(150, 1600);
    });
});
